import { Paths, PathValue } from "@mctypes/global.types";
import React from "react";
import { McInputNew, McTextAreaNew } from "../../../../../../components";
import { Radio, Paper, Stack, Title } from "@mantine/core";import {  IGKRapport,
  IGKVisualiseringMedRoeykPunktavsugResultater,
} from "@mcapps/shared/reportSchemas/gkReportSchema";
import ReportDocxImageContainer from "../../../ReportBoard/ReportDocxImageContainer";
const VisualiseringMedRoeykPunktavsug: React.FC<{
  onUpdateEditData: <P extends Paths<IGKRapport, 4>>(path: P, value: PathValue<IGKRapport, P>) => void;
  data: IGKVisualiseringMedRoeykPunktavsugResultater;
}> = ({ data, onUpdateEditData }) => {
  return (
    <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
      <Stack gap="xs">
        <Title order={4} fw={400}>Visualisering med røyk</Title>
        <div className="w-50 mt-0">
          <div>
            <McTextAreaNew
              label="Beskrivelse av luftstrøm:"
              value={data.inndata.beskrivelseAvLuftstroem}
              onChange={(e) =>
                onUpdateEditData(
                  "testResultater.visualiseringMedRoeykPunktavsug.inndata.beskrivelseAvLuftstroem",
                  e.target.value,
                )
              }
            />
          </div>
          <div>
            <div className="d-flex flex-column">
                            <Radio
                checked={data.inndata.godkjent === true}
                onChange={() =>
                onUpdateEditData("testResultater.visualiseringMedRoeykPunktavsug.inndata.godkjent", true)
                }
                label="Godkjent"
              />
                            <Radio
                checked={data.inndata.godkjent === false}
                onChange={() =>
                onUpdateEditData("testResultater.visualiseringMedRoeykPunktavsug.inndata.godkjent", false)
                }
                label="Ikke godkjent"
              />
            </div>
          </div>
        </div>
        <div className="mt-4">
          <ReportDocxImageContainer
            docxImageTag="visualiseringMedRoeykPunktavsug"
            title="Bilde av luftstrøm med forstyrrelser"
          />
          <div className="w-50">
            <McTextAreaNew
              label="Kommentar:"
              value={data.inndata.kommentar}
              onChange={(e) =>
                onUpdateEditData("testResultater.visualiseringMedRoeykPunktavsug.inndata.kommentar", e.target.value)
              }
            />
          </div>
        </div>
      </Stack>
    </Paper>
  );
};
export default VisualiseringMedRoeykPunktavsug;